export default "__VITE_ASSET__BQbfVh2r__"